/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Rank_Floor_ContinentalInputs */



/**
* | output |
* | --- |
* | "Continental championships" |
*
* @param {Tournaments_Rank_Floor_ContinentalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_rank_floor_continental = /** @type {((inputs?: Tournaments_Rank_Floor_ContinentalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Rank_Floor_ContinentalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Championnats continentaux")
	if (locale === "es") return /** @type {LocalizedString} */ ("Campeonatos continentales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Campeonatos continentais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionati continentali")
	return /** @type {LocalizedString} */ ("Continental championships")
});